import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Lock, Key } from 'lucide-react';
import AuthLayout from '../../components/auth/AuthLayout';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { authService } from '../../services/authService';

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const t = params.get('token');
    if (t) setToken(t);
  }, [params]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    setMessage(null);
    if (newPassword.length < 6) {
      setErr('Nova senha deve ter no mínimo 6 caracteres.');
      return;
    }
    if (newPassword !== confirm) {
      setErr('As senhas não coincidem.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await authService.resetPassword(token.trim(), newPassword);
      setMessage(res?.message || 'Senha redefinida com sucesso.');
      setTimeout(() => navigate('/entrar'), 1500);
    } catch (ex) {
      setErr(ex.message || 'Token inválido ou expirado.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Redefinir senha"
      subtitle="Defina uma nova senha. O token está no link do email recebido."
      footer={
        <Link to="/entrar" className="text-primary hover:underline">
          Voltar ao login
        </Link>
      }
    >
      {message && (
        <div className="bg-success/10 border border-success/30 text-success px-4 py-3 rounded-lg mb-4 text-sm">
          {message}
        </div>
      )}
      {err && (
        <div className="bg-error/10 border border-error/30 text-error px-4 py-3 rounded-lg mb-4 text-sm">
          {err}
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label="Token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          required
          leftIcon={<Key size={18} />}
        />
        <Input
          type="password"
          label="Nova senha"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          placeholder="••••••••"
          helpText="Mínimo 6 caracteres"
          leftIcon={<Lock size={18} />}
        />
        <Input
          type="password"
          label="Confirmar nova senha"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
          placeholder="••••••••"
          leftIcon={<Lock size={18} />}
        />
        <Button type="submit" fullWidth loading={submitting} size="lg">
          Redefinir senha
        </Button>
      </form>
    </AuthLayout>
  );
};

export default ResetPasswordPage;
